import { defineMessages } from "react-intl"

export const ROLE_EDIT_FORM_MESSAGES = defineMessages({
    role_label: {
        id: "role.form.new.role_label",
        defaultMessage: "Role Name",
    },
    save_btn: {
        id: "roles.form.edit.save_btn",
        defaultMessage: "Save",
    },
    delete_btn: {
        id: "role.form.edit.delete_btn",
        defaultMessage: "Delete role",
    },
    admin: {
        id: "role.form.admin_rolename",
        defaultMessage: "Administrator"
    },
    salesMan: {
        id: "role.form.salesperson_rolename",
        defaultMessage: "Salesperson"
    },
})


// WEBPACK FOOTER //
// ./src/utils/role/messages.ts